/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProvisioningNotificationStatusEnum } from './provisioningNotificationStatusEnum';
import { ProvisioningNotificationSourceTypeEnum } from './provisioningNotificationSourceTypeEnum';


export interface BillingProvisioningRequestPostSpec { 
    saasTransactionID: string;
    action?: string;
    sku?: string;
    serialNumber?: string;
    quantity?: string;
    subscriptionType?: string;
    pla?: string;
    serviceStartDate?: string;
    serviceEndDate?: string;
    erpCustAcctNumber?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    countryCode?: string;
    newTenantRequired?: string;
    tenantID?: string;
    information?: string;
    status: ProvisioningNotificationStatusEnum;
    info?: string;
    sourceType: ProvisioningNotificationSourceTypeEnum;
}
export namespace BillingProvisioningRequestPostSpec {
}


